import React, { useEffect, useMemo, useState } from 'react';
import { demoRegistry } from './demoRegistry';
import DemoEntryView from './DemoEntryView';

function readEntryFromUrl() {
  return new URLSearchParams(window.location.search).get('entry') || '';
}

export default function DesignSystemPage() {
  const [selectedId, setSelectedId] = useState(readEntryFromUrl());
  const [query, setQuery] = useState('');

  const categories = useMemo(() => {
    const groups = [];
    demoRegistry.forEach((demo) => {
      let group = groups.find((g) => g.category === demo.category);
      if (!group) {
        group = { category: demo.category, demos: [] };
        groups.push(group);
      }
      group.demos.push(demo);
    });
    return groups;
  }, []);

  // Client-side filter over the in-memory registry: an entry shows if its title OR
  // its category contains the query. Categories with no matching entries are hidden.
  const q = query.trim().toLowerCase();
  const filteredCategories = useMemo(() => {
    if (q === '') return categories;
    return categories
      .map((group) => {
        if (group.category.toLowerCase().includes(q)) return group; // category matched → keep all
        const demos = group.demos.filter((demo) => (demo.title || '').toLowerCase().includes(q));
        return { category: group.category, demos };
      })
      .filter((group) => group.demos.length > 0);
  }, [categories, q]);

  const selected = demoRegistry.find((d) => d.id === selectedId) || demoRegistry[0] || null;

  const selectEntry = (id) => {
    setSelectedId(id);
    const url = new URL(window.location.href);
    url.searchParams.set('entry', id);
    window.history.pushState({}, '', url);
  };

  useEffect(() => {
    const onPopState = () => setSelectedId(readEntryFromUrl());
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  return (
    <div className='bravo-ds dsg-page contentwrapper'>
      <nav className='dsg-catalog'>
        <div className='dsg-search'>
          <i className='fa-solid fa-magnifying-glass' />
          <input
            type='text'
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder='Search components...'
            aria-label='Search components'
          />
          {query && (
            <button
              type='button'
              className='dsg-search-x'
              onClick={() => setQuery('')}
              aria-label='Clear'
            >
              <i className='fa-solid fa-xmark' />
            </button>
          )}
        </div>
        {filteredCategories.length === 0 && <div className='dsg-empty'>No matches</div>}
        {filteredCategories.map((group) => (
          <div
            key={group.category}
            className='dsg-cat'
          >
            <div className='dsg-cat-title'>{group.category}</div>
            {group.demos.map((demo) => (
              <button
                key={demo.id}
                type='button'
                className={'dsg-entry' + (selected && selected.id === demo.id ? ' active' : '')}
                onClick={() => selectEntry(demo.id)}
              >
                {demo.title}
              </button>
            ))}
          </div>
        ))}
      </nav>
      <main className='dsg-content'>
        {selected ? (
          <DemoEntryView
            key={selected.id}
            demo={selected}
          />
        ) : (
          <div className='dsg-notes'>No demos registered yet.</div>
        )}
      </main>
    </div>
  );
}
